
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/properties",
      function () {
        return require("private-next-pages/system/properties.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/properties"])
      });
    }
  